import React from 'react';
import PropTypes from 'prop-types';
import Copy from 'copy-to-clipboard';

export class SocialButtons extends React.Component {
  constructor (props) {
    super(props);
    this.windowSettings = this.windowSettings.bind(this);
    this.fbShare = this.fbShare.bind(this);
    this.twitterShare = this.twitterShare.bind(this);
    this.pinterestShare = this.pinterestShare.bind(this);
    this.emailShare = this.emailShare.bind(this);
    this.copyLink = this.copyLink.bind(this);

    this.state = {
      isCopied: false
    };
  }

  windowSettings (winWidth, winHeight) {
    const winTop = (window.screen.height / 2) - (winHeight / 2);
    const winLeft = (window.screen.width / 2) - (winWidth / 2);
    return `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`;
  }

  fbShare (e) {
    const { listing = {}, origin } = this.props;
    const [appId, url, winWidth, winHeight] = listing.fbShare || [];
    const windowSettings = this.windowSettings(winWidth, winHeight);
    e.preventDefault();
    analyticsIntegrations.shareBtnClick(listing, origin, 'facebook');
    window.open(`http://www.facebook.com/sharer.php?app_id=${appId}&sdk=joey&u=${url}%3Futm_source%3Dfacebook%26utm_campaign%3Dlisting_sharing&display=popup&ref=plugin&src=share_button`, 'sharer', windowSettings);
  }

  twitterShare (e) {
    const { listing = {}, origin } = this.props;
    const [city, encodeUrl, listingId, winHeight, winWidth] = listing.twitterShare || [];
    const windowSettings = this.windowSettings(winWidth, winHeight);
    e.preventDefault();
    analyticsIntegrations.shareBtnClick(listing, origin, 'twitter');
    window.open(`https://twitter.com/intent/tweet?source=tweetbutton&text=Check+out+this+@Peerspace+location+in+%23${city}+-&url=${encodeUrl}%2Fpages%2Flistings%2F${listingId}%3Futm_source%3Dtwitter%26utm_campaign%3Dlisting_sharing&related=peerspace`, 'sharer', windowSettings);
  }

  pinterestShare (e) {
    const { listing = {}, origin } = this.props;
    const [city, image, encodeUrl, listingId, winHeight, winWidth] = listing.pinterestShare || [];
    const windowSettings = this.windowSettings(winWidth, winHeight);
    e.preventDefault();
    analyticsIntegrations.shareBtnClick(listing, origin, 'pinterest');
    window.open(`https://pinterest.com/pin/create/button?description=Check+out+this+Peerspace+location+in+${city}&media=${encodeURIComponent(image)}&url=${encodeUrl}%2Fpages%2Flistings%2F${listingId}%3Futm_source%3Dpinterest%26utm_campaign%3Dlisting_sharing`, 'sharer', windowSettings);
  }

  copyLink (e) {
    const { listing, origin } = this.props;
    e.preventDefault();
    analyticsIntegrations.shareBtnClick(listing, origin, 'copy link');
    // we use the same url as facebook
    const [, url] = listing.fbShare || [];
    Copy(`${url}?utm_source=copy_link&utm_campaign=listing_sharing`);
    this.setState({
      isCopied: true
    }, () => {
      setTimeout(() => {
        this.setState({ isCopied: false });
      }, 1000);
    });
  }

  emailShare (e) {
    const { listing, origin } = this.props;
    e.preventDefault();
    analyticsIntegrations.shareBtnClick(listing, origin, 'email');
    window.location.href = `${listing.emailShare}%3Futm_source%3Demail%26utm_campaign%3Dlisting_sharing`;
  }

  render () {
    return (
      <div>
        <ul className="list-unstyled social-buttons">
          <li>
            <button className="btn btn-primary btn-block classic" id="copy-link" rel="nofollow" title="Email" onClick={this.copyLink}>
              <div>
                <span className="ico ico-md icon-link" />
                <span className="margin-sm-left">{this.state.isCopied ? 'Copied!' : 'Copy Link'}</span>
              </div>
            </button>
          </li>
          <li>
            <button onClick={this.emailShare} className="btn btn-block btn-outline classic email">
              <i className="ico icon-mail-outline margin-md-right" />
              <span>Email</span>
            </button>
          </li>
          <li>
            <button className="btn btn-outline btn-block classic fb flex middle center" id="fb" rel="nofollow" title="Facebook" target="_blank" onClick={this.fbShare}>
              <span className="ico ico-md icon-facebook" />
              <span className="margin-sm-left">Share</span>
            </button>
          </li>
          <li>
            <button className="btn btn-outline btn-block classic twitter flex middle center" id="twitter" rel="nofollow" title="Twitter" target="_blank" onClick={this.twitterShare}>
              <span className="ico ico-md icon-twitter" />
              <span className="margin-sm-left">Tweet</span>
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

SocialButtons.propTypes = {
  listing: PropTypes.object,
  origin: PropTypes.string
};
